/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Seat_Change_Success_MinimumInputs */



/**
* | output |
* | --- |
* | "Done – the empty seat is now a {type} seat." |
*
* @param {Seat_Change_Success_MinimumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_success_minimum = /** @type {((inputs: Seat_Change_Success_MinimumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Success_MinimumInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Erledigt – der freie Platz ist jetzt ein ${i?.type}-Platz.`)
	return /** @type {LocalizedString} */ (`Done – the empty seat is now a ${i?.type} seat.`)
});